import { baseApi } from "@/app/store/api/baseApi";

export interface OrgPreferences {
  volunteer_screening_enabled: boolean;
  document_checklists_enabled: boolean;
  inventory_enabled: boolean;
  pos_enabled: boolean;
  grant_management_enabled: boolean;
  batch_giving_enabled: boolean;
  campaign_actions_enabled: boolean;
  event_metrics_enabled: boolean;
  manual_interaction_logging_enabled: boolean;
  bulk_role_assignment_enabled: boolean;
  single_program_enrollment: boolean;
  inventory_valuation_method: "fifo" | "lifo" | "weighted_avg";
  require_shift_approval: boolean;
  checkin_requires_enrollment: boolean;
  require_fund_description: boolean;
  require_transfer_reference?: boolean;
  require_transfer_attachment?: boolean;
  require_release_attachment?: boolean;
  require_pledge_expected_date?: boolean;
  require_pledge_attachment?: boolean;
  public_donor_form_enabled?: boolean;
  online_donations_enabled?: boolean;
  auto_post_online_donations?: boolean;
  donor_form_share_subject?: string;
  donor_form_share_body?: string;
  donor_form_amount_presets?: string[];
  donor_form_thank_you_message?: string;
  donor_form_intro_message?: string;
  online_donation_default_fund_id?: number | null;
  /** Staff see per-member hours on a program. Admins always do. */
  show_program_hours_to_staff?: boolean;
  show_inventory_pricing_to_staff: boolean;
  show_donor_tab_in_members: boolean;
  shift_work_areas: string[];
  /** Hours before start after which a person can no longer drop their shift. */
  shift_drop_cutoff_hours?: number;
}

const preferencesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreferences: builder.query<OrgPreferences, void>({
      query: () => "/manifest/preferences/read/",
      providesTags: ["Preferences"],
    }),
    updatePreferences: builder.mutation<OrgPreferences, Partial<OrgPreferences>>({
      query: (body) => ({
        url: "/manifest/preferences/",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Preferences"],
    }),
    addShiftWorkArea: builder.mutation<{ label: string }, { label: string }>({
      query: (body) => ({
        url: "/manifest/preferences/shift-work-areas/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Preferences"],
    }),
    listPreferencePresets: builder.query<
      {
        presets: {
          id: string;
          label: string;
          description: string;
          changes: { key: string; label: string; value: boolean }[];
        }[];
      },
      void
    >({
      query: () => "/manifest/preferences/presets/",
    }),
    applyPreferencePreset: builder.mutation<{ preset: string; applied: boolean }, { preset: string }>({
      query: (body) => ({
        url: "/manifest/preferences/apply-preset/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Preferences"],
    }),
  }),
});

export const {
  useGetPreferencesQuery,
  useUpdatePreferencesMutation,
  useAddShiftWorkAreaMutation,
  useListPreferencePresetsQuery,
  useApplyPreferencePresetMutation,
} = preferencesApi;
